import { render, staticRenderFns } from "./LoginBbalance.vue?vue&type=template&id=71b23bdc&scoped=true&"
import script from "./LoginBbalance.vue?vue&type=script&lang=js&"
export * from "./LoginBbalance.vue?vue&type=script&lang=js&"
import style0 from "./LoginBbalance.vue?vue&type=style&index=0&id=71b23bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b23bdc",
  null
  
)

export default component.exports